"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ApolloTextCacheHelper_1 = require("@aurora/shared-apollo/helpers/ApolloTextCacheHelper");
const apolloCacheHelper_1 = require("@aurora/shared-apollo/apolloCacheHelper");
const CachedAsset_fragment_graphql_1 = __importDefault(require("@aurora/shared-apollo/resolvers/assets/CachedAsset.fragment.graphql"));
const log_1 = require("@aurora/shared-utils/log");
const log = (0, log_1.getLog)(module);
/**
 * Helper for working with i18n text.
 *
 * @author Dolan Halbrook
 */
// eslint-disable-next-line unicorn/no-static-only-class
class TextHelper {
    /**
     * Maps a text bundle's locally namespaced keys to globally namespaced keys for use with Intl.
     * @param namespace the namespace
     * @param bundle the text bundle to modify
     * @return the same text bundle instance with modified keys
     */
    static namespaceTextBundleKeys(namespace, bundle) {
        const result = {};
        // namespace the keys
        Object.keys(bundle).forEach(key => {
            result[`${namespace}/${key}`] = bundle[key];
        });
        return result;
    }
    /**
     * Re-reads text and overrides into cache.  Useful to avoid client slowness after an Apollo cache eviction such as on
     * login or logout.
     *
     * @param client an apollo client instance
     * @param intl an intl instance
     * @param lastModified the last mod
     */
    static rebuildCaches(client, intl, lastModified) {
        return __awaiter(this, void 0, void 0, function* () {
            const now = performance.now();
            log.debug('Rebuilding text caches.');
            const { locale, messages } = intl;
            const keyMap = new Map();
            Object.keys(messages).forEach(key => {
                const tenantSeparatorIndex = key.indexOf(':');
                const keyNoTenant = key.slice(tenantSeparatorIndex + 1);
                const indexOfVariantSeparator = keyNoTenant.indexOf('@');
                /**
                 * LIA-80133 Checking the index of `@` because the id of the component used as namespace of instance has `/`.
                 */
                const namespaceSeparatorIndex = indexOfVariantSeparator === -1
                    ? keyNoTenant.lastIndexOf('/')
                    : keyNoTenant.slice(0, indexOfVariantSeparator).lastIndexOf('/');
                const namespace = keyNoTenant.slice(0, namespaceSeparatorIndex);
                const textKey = keyNoTenant.slice(namespaceSeparatorIndex + 1);
                const bundle = keyMap.has(namespace) ? keyMap.get(namespace) : {};
                if (!keyMap.has(namespace)) {
                    keyMap.set(namespace, bundle);
                }
                Object.assign(bundle, { [textKey]: messages[key] });
            });
            keyMap.forEach((value, namespace) => {
                const id = (0, ApolloTextCacheHelper_1.buildPrefixedTextBundleId)(locale, namespace, lastModified);
                (0, apolloCacheHelper_1.cacheFragment)(client, CachedAsset_fragment_graphql_1.default, id, {
                    value,
                    localOverride: false
                });
            });
            log.debug('Text cache rebuilt in %dms', performance.now() - now);
            return;
        });
    }
}
exports.default = TextHelper;
//# sourceMappingURL=TextHelper.js.map